import { render } from "./SpeakingRecordingCard.vue?vue&type=template&id=246cd82d"
import script from "./SpeakingRecordingCard.vue?vue&type=script&lang=js"
export * from "./SpeakingRecordingCard.vue?vue&type=script&lang=js"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__